import React, {Component} from 'react';
import {Row, Col, Card, CardHeader, CardBody, Button, CardFooter, Modal, ModalHeader, ModalFooter, ModalBody, Input } from 'reactstrap';
import { NavLink, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';


class StatusPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      uploadModalOpen:false,
      navigate: false,
      path:"",
    }


  }


  componentWillMount() {
        if(!this.props.user.isLoggedIn) {
          this.setState({
            path:"login",
            navigate:true

          })
        }

  }


  render() {

      const { navigate, path } = this.state

      // here is the important part
      if (navigate) {
        console.log(path);
        return <Redirect to={ "/" + path } push={true} />
      }




    return (
      <div className="animated fadeIn">
       

      </div>
    )
  }
}

function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}

export default connect(mapStateToProps)(StatusPage);



// WEBPACK FOOTER //
// ./src/views/Components/Social/yourStoryboards.js